module.exports = __webpack_public_path__ + "static/media/left-arrow.a7080bb6.svg";